/** 进件表单选项，来源：fxj-miniapp/miniprogram/constants/form-options.ts */

export const PROFESSION_OPTIONS = [
  { dictValue: 1, dictLabel: "个体户/企业主" },
  { dictValue: 0, dictLabel: "上班族" },
  { dictValue: 0, dictLabel: "公务员/国企事业单位" },
  { dictValue: 0, dictLabel: "自由职业" },
];

export const SOCIAL_OPTIONS = [
  { dictValue: 1, dictLabel: "6个月以上" },
  { dictValue: 1, dictLabel: "6个月以下" },
  { dictValue: 0, dictLabel: "无本地社保" },
];

export const ACCUMULATION_OPTIONS = [
  { dictValue: 1, dictLabel: "6个月以上" },
  { dictValue: 1, dictLabel: "6个月以下" },
  { dictValue: 0, dictLabel: "无本地公积金" },
];

export const CAR_OPTIONS = [
  { dictValue: 1, dictLabel: "有且接受抵押" },
  { dictValue: 1, dictLabel: "有车产" },
  { dictValue: 0, dictLabel: "无车产" },
];

export const HOUSE_OPTIONS = [
  { dictValue: 1, dictLabel: "有且接受抵押" },
  { dictValue: 1, dictLabel: "有房产" },
  { dictValue: 0, dictLabel: "无房产" },
];

export const CREDIT_OPTIONS = [
  { dictValue: "700以上", dictLabel: "700分以上" },
  { dictValue: "650-700", dictLabel: "650-699分" },
  { dictValue: "600-650", dictLabel: "600-649分" },
  { dictValue: "600以下", dictLabel: "600分以下" },
];

export const OVERDUE_OPTIONS = [
  { dictValue: 0, dictLabel: "无逾期" },
  { dictValue: 1, dictLabel: "有逾期" },
];

export const FORM_STEPS = [
  { key: "profession", title: "您的职业是什么？", options: PROFESSION_OPTIONS, assetVal: 6 },
  { key: "social", title: "您的社保情况？", options: SOCIAL_OPTIONS, assetVal: 4 },
  { key: "accumulation", title: "您的公积金情况？", options: ACCUMULATION_OPTIONS, assetVal: 3 },
  { key: "car", title: "您的车产情况？", options: CAR_OPTIONS, assetVal: 2 },
  { key: "house", title: "您的房产情况？", options: HOUSE_OPTIONS, assetVal: 1 },
  { key: "credit", title: "您的芝麻分是多少？", options: CREDIT_OPTIONS },
  { key: "overdue", title: "您的逾期情况？", options: OVERDUE_OPTIONS },
];

function pushAssetsVal(options, selectedLabel, assetVal, assets) {
  if (!selectedLabel) return;
  const matched = options.find((item) => item.dictLabel === selectedLabel);
  if (!matched || matched.dictValue === 0) return;
  assets.push(assetVal);
}

export function buildAssetsArray(answers) {
  const assets = [];
  pushAssetsVal(HOUSE_OPTIONS, answers.house?.dictLabel, 1, assets);
  pushAssetsVal(CAR_OPTIONS, answers.car?.dictLabel, 2, assets);
  pushAssetsVal(ACCUMULATION_OPTIONS, answers.accumulation?.dictLabel, 3, assets);
  pushAssetsVal(SOCIAL_OPTIONS, answers.social?.dictLabel, 4, assets);
  pushAssetsVal(PROFESSION_OPTIONS, answers.profession?.dictLabel, 6, assets);
  return assets;
}

export const TOTAL_FORM_STEPS = FORM_STEPS.length;
